import { Share2 } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';

interface PivotPoint {
    ref: string;
    why: string;
}

interface PivotsAndHingesCardProps {
    pivots: PivotPoint[];
    isExpanded: boolean;
    onToggleExpansion: () => void;
    onRefClick?: (ref: string) => void;
    thumbnailUrl?: string;
}

export function PivotsAndHingesCard({ pivots, isExpanded, onToggleExpansion, onRefClick, thumbnailUrl }: PivotsAndHingesCardProps) {
    if (!pivots || pivots.length === 0) return null;

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            icon={Share2}
            thumbnailUrl={thumbnailUrl}
            header={
                <div className="flex flex-col gap-1">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/50">Dynamic Transitions</div>
                    <h3 className="text-xl font-serif font-medium text-foreground/90 leading-tight">Structural Pivots & Hinges</h3>
                </div>
            }
        >
            <div className="pt-4 space-y-6">
                <p className="text-xs text-muted-foreground italic mb-2">
                    These "pivot points" mark decisive shifts in the book's narrative flow or theological argument.
                </p>

                <div className="space-y-4">
                    {pivots.map((pivot, idx) => (
                        <div key={idx} className="relative pl-4 border-l border-primary/20 space-y-1">
                            <span
                                className="text-[10px] font-mono font-bold text-primary/60 cursor-pointer hover:text-primary transition-colors"
                                onClick={() => onRefClick?.(pivot.ref)}
                            >
                                {pivot.ref}
                            </span>
                            <p className="text-sm text-foreground/80 leading-relaxed font-light">
                                {pivot.why}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </DiscoveryCard>
    );
}
